import { Component, Input, OnInit, ViewEncapsulation, forwardRef } from '@angular/core';
import { ControlValueAccessor, FormControl, NG_VALUE_ACCESSOR } from '@angular/forms';
import moment from 'moment';

@Component({
  selector: 'app-form-input-password',
  standalone: false,
  templateUrl: './form-input-password.component.html',
  styleUrls: ['./form-input-password.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => FormInputPasswordComponent),
      multi: true
    }
  ]
})
export class FormInputPasswordComponent implements OnInit, ControlValueAccessor {
  @Input() feedback: boolean;
  @Input() field: string;
  @Input() formControl: FormControl;
  @Input() label: string;

  public id: string;

  public onChange = (_: any) => {
  };
  public onTouch = () => {
  };

  constructor() {
  }

  ngOnInit(): void {
    this.id = `${this.field}-${moment().unix()}`;
  }

  // value accessor functions
  writeValue(): void {
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouch = fn;
  }

  // function to catch input changes and update form in parent
  public onInput($event: any): void {
    this.onTouch();
    this.onChange($event?.target['value']);
  }
}
